<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <p class="large_label">支払金額 : ￥{{amount}}</p>
      <template v-if="customClaim.isOwner">
        <p>クレジットカード情報が入力されると、依頼を正式に発注します</p>
        <p><input type="checkbox" class="" id="terms_check_id" v-model="isTermsCheck"/>
          <label for="terms_check_id"> 私は<a target="_blank" href="/information/terms" class="link_label">利用規約</a>に同意します。</label>
        </p>

        <PaymentStripe v-if="isTermsCheck" :matching-id="matchingId" :amount="amount" />
      </template>
      <template v-else>
        <p>管理者の決済をお待ちください</p>
      </template>
    </div>
  </div>

</template>

<script>
  import PaymentStripe from "@/components/objects/stripe/PaymentStripe";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import {mapGetters} from "vuex";

  export default {
    name: "MatchingPayment",

    components: {PaymentStripe},

    mixins: [collection],

    data() {
      return {
        matchingId: '',
        isTermsCheck: false,
        amount: 0,
      }
    },

    computed: {
      ...mapGetters({customClaim: 'auth/customClaim'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace('/matching/meeting/payment/', '');
      this.matchingId = this.matchingId.replace(/\/*$/, '');

      await this.getDoc(COLLECTION_NAMES.MATCHINGS, this.matchingId).then(async readMatching => {
        await this.getDoc(COLLECTION_NAMES.WORKS, readMatching.work.id).then(readWork => {
          this.amount = readWork.rewards - readWork.paidRewards;
        });
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include form-contents();

      .payment_stripe {
        margin-top: 2rem;
        width: 80%;
      }
    }
  }
</style>